<script setup lang="ts">
import { useAuthProcessStore } from '#imports';

const service = useAuthProcessStore();

const form = ref();

async function onSubmit() {
  form.value.clear();
  await service.register(errors => setBackendErrors(form.value, errors));
}
</script>

<template>
  <UForm
    ref="form"
    :schema="service.registerSchema()"
    :state="service.data"
    :validate-on="['submit']"
    class="space-y-4"
    @submit="onSubmit"
  >
    <UCard>
      <template #header>
        <slot name="header" />
      </template>

      <UFormGroup :label="$t('auth.name')" required name="name">
        <UInput v-model="service.data.name" icon="i-heroicons-identification" :placeholder="$t('auth.namePlaceholder')" />
      </UFormGroup>

      <UFormGroup :label="$t('auth.email')" icon="i-heroicons-envelope" required name="email" class="mt-2">
        <UInput v-model="service.data.email" :placeholder="$t('auth.emailPlaceholder')" />
      </UFormGroup>

      <UFormGroup :label="$t('auth.password')" required name="password" class="mt-2">
        <template #hint>
          <UButton
            icon="i-bi-stars"
            size="sm"
            color="gray"
            square
            variant="ghost"
            @click="service.generateRandomPassword"
          />
          <UButton
            :icon="service.showPassword ? 'i-heroicons-eye' : 'i-heroicons-eye-slash'"
            size="sm"
            color="primary"
            square
            variant="ghost"
            @click="service.togglePasswordVisible"
          />
        </template>
        <UInput
          v-model="service.data.password"
          icon="i-heroicons-finger-print"
          :type="service.passwordInputType"
        />
      </UFormGroup>

      <UFormGroup :label="$t('auth.passwordConfirm')" required name="password_confirmation" class="mt-2">
        <UInput
          v-model="service.data.password_confirmation"
          icon="i-heroicons-finger-print"
          :type="service.passwordInputType"
        />
      </UFormGroup>

      <template #footer>
        <div class="flex items-center">
          <UButton type="submit" icon="i-bi-check" :loading="service.loading">
            {{ $t('auth.submitRegister') }}
          </UButton>
          <UButton :to="useUrlWithRedirect('/auth/login')" class="ml-2" variant="link" :disabled="service.loading">
            {{ $t('auth.linkToLogin') }}
          </UButton>
        </div>
      </template>
    </UCard>
  </UForm>
</template>
